/*
  Ritual Bar — shop + BOX bundle builder (Pause Rituals)
  - Tab filtering (show/hide cards by data-cat, no reload).
  - The "box" is a staged KIT (localStorage): tap a card to add/remove it (one of each).
  - Live total with a tiered discount preview (2 → 10%, 4 → 20%): shows the original price
    struck through + the discounted price, recalculated as items are added/removed.
  - Drives the box progress bar (mobile) AND the hero progress bar (data-rbh-*).
  - Mobile: fixed bottom drawer, swipe/tap the handle to open/close.
  - "Add Ritual to Cart" → adds the WHOLE kit at once as a bundle (shared line property),
    so it reads as one ritual in the cart, then clears the box and opens the cart.
*/
(function () {
  var STORE_KEY = 'pr_ritual_box_v1';

  function money(cents) {
    var n = Math.round((cents || 0) / 100);
    try { return '₹' + n.toLocaleString('en-IN'); } catch (e) { return '₹' + n; }
  }
  function loadBox() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || []; } catch (e) { return []; }
  }
  function saveBox(box) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(box)); } catch (e) {}
  }

  function setup(rbs) {
    if (rbs.dataset.rbsReady === '1') return;
    rbs.dataset.rbsReady = '1';

    /* ---------- tab filtering ---------- */
    var tabs = Array.prototype.slice.call(rbs.querySelectorAll('[data-rbs-tab]'));
    var grid = rbs.querySelector('[data-rbs-grid]');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.rbs__card')) : [];
    if (grid && tabs.length) {
      var emptyMsg = document.createElement('p');
      emptyMsg.hidden = true;
      emptyMsg.style.cssText = 'grid-column:1/-1;text-align:center;color:#8a8a8a;font:14px/1.6 var(--brand-body,sans-serif);padding:40px 0;';
      emptyMsg.textContent = 'No products in this category yet.';
      grid.appendChild(emptyMsg);
      var filter = function (cat) {
        var shown = 0;
        cards.forEach(function (c) {
          var ok = cat === 'all' || c.getAttribute('data-cat') === cat;
          c.hidden = !ok;
          if (ok) shown++;
        });
        emptyMsg.hidden = shown > 0;
      };
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var a = t === tab;
            t.classList.toggle('is-active', a);
            t.setAttribute('aria-selected', a ? 'true' : 'false');
          });
          filter(tab.getAttribute('data-cat'));
          tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        });
      });
    }

    /* ---------- box (staged kit) ---------- */
    var boxEl = rbs.querySelector('[data-rbs-box]');
    if (!boxEl) return;

    var listEl = boxEl.querySelector('[data-box-list]');
    var emptyEl = boxEl.querySelector('[data-box-empty]');
    var totalEl = boxEl.querySelector('[data-box-total]');
    var wasEl = boxEl.querySelector('[data-box-total-was]');
    var ctaEl = boxEl.querySelector('[data-box-checkout]');
    var progressEl = boxEl.querySelector('[data-box-progress]');
    var progressLabel = boxEl.querySelector('[data-box-progress-label]');
    var fillEl = boxEl.querySelector('[data-box-fill]');
    var scrim = rbs.querySelector('[data-box-scrim]');
    var handle = boxEl.querySelector('[data-box-toggle]');

    var t1n = parseInt(boxEl.dataset.tier1Items, 10) || 0;
    var t1p = parseInt(boxEl.dataset.tier1Pct, 10) || 0;
    var t2n = parseInt(boxEl.dataset.tier2Items, 10) || 0;
    var t2p = parseInt(boxEl.dataset.tier2Pct, 10) || 0;
    var note = boxEl.dataset.note || '';
    var kitLabel = boxEl.dataset.kitLabel || '';
    var maxN = Math.max(t1n, t2n, 1);

    var box = loadBox();
    var addBtns = Array.prototype.slice.call(rbs.querySelectorAll('[data-rbs-add]'));

    function inBox(id) { return box.some(function (i) { return i.id === id; }); }

    function discountFor(count) {
      if (t2n && count >= t2n) return t2p;
      if (t1n && count >= t1n) return t1p;
      return 0;
    }

    function addText(n, pct) {
      return 'Add ' + n + ' more ' + (n === 1 ? 'product' : 'products') + ' to get ' + pct + '% off 🎉';
    }
    function progressText(count) {
      if (t1n && count < t1n) return addText(t1n - count, t1p);
      if (t2n && count < t2n) return addText(t2n - count, t2p);
      var pct = discountFor(count);
      return pct > 0 ? "You've unlocked " + pct + '% off 🎉' : '';
    }

    function setReached(els, count) {
      els.forEach(function (n) {
        var tier = n.getAttribute('data-box-marker') || n.getAttribute('data-rbh-marker');
        var need = tier === '2' ? t2n : t1n;
        n.classList.toggle('is-reached', !!(need && count >= need));
      });
    }

    function setMarkers() {
      var m1 = t2n ? Math.round((t1n / maxN) * 100) : 50;
      boxEl.querySelectorAll('[data-box-marker="1"]').forEach(function (m) { m.style.left = m1 + '%'; });
      boxEl.querySelectorAll('[data-box-marker="2"]').forEach(function (m) { m.style.left = '100%'; });
      document.querySelectorAll('[data-rbh-marker="1"]').forEach(function (m) { m.style.left = m1 + '%'; });
      document.querySelectorAll('[data-rbh-marker="2"]').forEach(function (m) { m.style.left = '100%'; });
    }

    /* the hero bar mirrors the box: same fill ratio, nodes, label */
    function syncHero(count, ratio, text) {
      document.querySelectorAll('[data-rbh-fill]').forEach(function (f) { f.style.transform = 'scaleX(' + ratio + ')'; });
      document.querySelectorAll('[data-rbh-label]').forEach(function (l) { l.innerHTML = text; });
      setReached(document.querySelectorAll('[data-rbh-marker]'), count);
    }

    function itemHTML(i, pct) {
      var priceInner;
      if (pct > 0) {
        var disc = Math.round(i.price * (1 - pct / 100));
        priceInner =
          '<s class="rb-box__item-was">' + money(i.price) + '</s>' +
          '<span class="rb-box__item-amount">' + money(disc) + '</span>';
      } else {
        priceInner = '<span class="rb-box__item-amount">' + money(i.price) + '</span>';
      }
      return '' +
        '<div class="rb-box__item" data-box-item="' + i.id + '">' +
          '<div class="rb-box__item-main">' +
            '<div class="rb-box__item-media">' + (i.image ? '<img src="' + i.image + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="rb-box__item-text">' +
              '<p class="rb-box__item-name">' + i.title + '</p>' +
              '<p class="rb-box__item-price">' + priceInner +
                (note ? '<span class="rb-box__item-note">' + note + '</span>' : '') + '</p>' +
            '</div>' +
          '</div>' +
          '<button class="rb-box__item-x" type="button" data-box-remove="' + i.id + '" aria-label="Remove ' + i.title + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>' +
          '</button>' +
        '</div>';
    }

    function render() {
      var count = box.length;
      var pct = discountFor(count);

      // list — each item shows its own discounted price when the kit qualifies
      Array.prototype.slice.call(listEl.querySelectorAll('.rb-box__item')).forEach(function (n) { n.remove(); });
      if (emptyEl) emptyEl.hidden = count > 0;
      if (count) listEl.insertAdjacentHTML('beforeend', box.map(function (i) { return itemHTML(i, pct); }).join(''));

      // total + tiered discount preview (original struck through + discounted)
      var subtotal = box.reduce(function (s, i) { return s + (i.price || 0); }, 0);
      var discounted = Math.round(subtotal * (1 - pct / 100));
      if (totalEl) totalEl.textContent = count ? money(discounted) : '—';
      if (wasEl) { wasEl.hidden = !(count && pct > 0); wasEl.textContent = money(subtotal); }

      // progress (box + hero)
      var txt = progressText(count);
      var ratio = Math.min(count / maxN, 1);
      if (progressEl) progressEl.hidden = count === 0;
      if (progressLabel) progressLabel.innerHTML = txt;
      if (fillEl) fillEl.style.transform = 'scaleX(' + ratio + ')';
      setReached(boxEl.querySelectorAll('[data-box-marker]'), count);
      syncHero(count, ratio, txt);

      // cta + mobile visibility
      if (ctaEl) ctaEl.disabled = count === 0;
      boxEl.classList.toggle('is-empty', count === 0);
      if (count === 0) closeDrawer();

      // card button states
      addBtns.forEach(function (b) {
        var added = inBox(b.dataset.id);
        b.classList.toggle('is-added', added);
        var lbl = b.querySelector('.rbs__add-label');
        if (lbl) {
          if (!b.dataset.label0) b.dataset.label0 = lbl.textContent;
          lbl.textContent = added ? 'Added ✓' : b.dataset.label0;
        }
      });

      // reserve page-bottom space so the fixed mobile bar never covers the footer
      requestAnimationFrame(reserveBottomSpace);
    }

    function add(data) { if (!inBox(data.id)) { box.push(data); saveBox(box); render(); } }
    function remove(id) { box = box.filter(function (i) { return i.id !== id; }); saveBox(box); render(); }

    // tap a card → toggle in the box (staged, not the cart)
    addBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.dataset.id;
        if (inBox(id)) { remove(id); return; }
        add({
          id: id,
          title: b.dataset.title || '',
          price: parseInt(b.dataset.price, 10) || 0,
          image: b.dataset.image || '',
          url: b.dataset.url || ''
        });
      });
    });

    // X in the box → remove from the box
    listEl.addEventListener('click', function (e) {
      var x = e.target.closest('[data-box-remove]');
      if (x) remove(x.getAttribute('data-box-remove'));
    });

    /* ---------- mobile drawer ---------- */
    function openDrawer() { boxEl.classList.add('is-open'); if (scrim) scrim.hidden = false; }
    function closeDrawer() { boxEl.classList.remove('is-open'); if (scrim) scrim.hidden = true; }
    if (handle) handle.addEventListener('click', function () { boxEl.classList.contains('is-open') ? closeDrawer() : openDrawer(); });
    if (scrim) scrim.addEventListener('click', closeDrawer);

    /* ---------- keep the footer clear of the fixed mobile bar ----------
       The .rb-box is position:fixed at the viewport bottom on mobile, so it overlaps the
       footer. Reserve padding-bottom on <body> equal to the COLLAPSED bar height so the
       footer scrolls fully above it. Cleared on desktop or when the bar is empty/hidden.
       (The open drawer overlays via the scrim, so we keep the collapsed value.) */
    function reserveBottomSpace() {
      var mobile = window.matchMedia('(max-width: 989px)').matches;
      if (!mobile || boxEl.classList.contains('is-empty')) {
        document.body.style.paddingBottom = '';
        return;
      }
      if (!boxEl.classList.contains('is-open')) boxEl.dataset.barH = boxEl.offsetHeight;
      var h = parseInt(boxEl.dataset.barH, 10) || boxEl.offsetHeight;
      document.body.style.paddingBottom = h + 12 + 'px';
    }
    window.addEventListener('resize', function () { requestAnimationFrame(reserveBottomSpace); });
    var sy = 0;
    boxEl.addEventListener('touchstart', function (e) { sy = e.changedTouches[0].clientY; }, { passive: true });
    boxEl.addEventListener('touchend', function (e) {
      var dy = e.changedTouches[0].clientY - sy;
      if (dy < -40) openDrawer();
      else if (dy > 40) closeDrawer();
    }, { passive: true });

    /* ---------- Add Ritual to Cart → whole kit as one bundle ---------- */
    if (ctaEl) {
      ctaEl.addEventListener('click', function () {
        if (!box.length || ctaEl.disabled) return;
        ctaEl.disabled = true;
        var items = box.map(function (i) {
          var it = { id: i.id, quantity: 1 };
          if (kitLabel) it.properties = { 'Ritual Kit': kitLabel };
          return it;
        });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () { box = []; saveBox(box); window.location.href = '/cart'; })
          .catch(function () { ctaEl.disabled = false; });
      });
    }

    setMarkers();
    render();
  }

  function init(root) { (root || document).querySelectorAll('[data-rbs]').forEach(setup); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
